module.exports = __webpack_public_path__ + "static/img/hero-book-logo.f27ae101.png";